import { nanoIdSchema } from "../shared/id.mjs";
import { z } from "zod";
//#region src/api/orpc/task/output.ts
/**
* Shared serialized representation of a generation task.
*
* This is the response shape returned by every task-producing endpoint
* (image.create, referenceVideo.create, internal task creation/edit, etc.).
* It intentionally lives in `task/` rather than `image/` because it is *not*
* image-specific — extracting it here lets multiple contracts (image,
* referenceVideo, internal/task, internal/taskEdit) share a single source of
* truth without depending on each other.
*/
const taskOutputSchema = z.object({
	id: z.string(),
	userId: z.string(),
	status: z.string(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	startedAt: z.iso.datetime().optional(),
	endAt: z.iso.datetime().optional(),
	paidQuota: z.number().int().optional(),
	outputs: z.object({
		mediaIds: z.array(z.string()),
		mediaUrls: z.array(z.string().nullable())
	})
});
/**
* Extended task shape for `GET /task/:id` style endpoints that can opt-in to
* heavier fields like raw parameters via `with_parameters=true`.
*/
const getTaskOutputSchema = taskOutputSchema.extend({ parameters: z.record(z.string(), z.unknown()).optional() });
/**
* Path/query input for fetching a task by id.
*
* `with_parameters` is a stringbool because it arrives via the query string
* (`?with_parameters=true`); `z.stringbool()` coerces "true"/"false" forms.
*/
const getTaskInputSchema = z.object({
	id: nanoIdSchema,
	with_parameters: z.stringbool().optional()
});
//#endregion
export { getTaskInputSchema, getTaskOutputSchema, taskOutputSchema };
